<template>
    <section class="benefits-list bg-white" id="benefits">
        <div class="container">
            <h2 class="benefits-list__title">Наши преимущества</h2>
            <div class="benefits-list__top">
                <div class="benefits-list__navigation" v-if="showControls">
                    <button @click="prev" class="prev" :disabled="swiperProgress <= 0"></button>
                    <button @click="next" class="next" :disabled="swiperProgress >= 1"></button>
                </div>
            </div>
            <div class="benefits-list__carousel" :class="{nonEvent : !showControls}">
                <div v-swiper:swiper="swiperOptions" @slide-change="onSlideChange">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide med-pnd-benefits-img-slider__item-wrapper"  v-for="(item, key) of benefits" :key="key">
                            <div class="med-pnd-benefits-img-slider__item">
                                <div class="med-pnd-benefits-img">
                                    <img :src="item.img" alt="">
                                </div>
                                <div class="med-pnd-benefits-title" v-html="item.title"></div>
                                <div class="med-pnd-benefits-text" v-html="item.text"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {directive} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'

export default {
    name: 'Benefits',
    props: {
        benefits: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            swiperOptions: {
                lazy: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 15,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1025: {
                        slidesPerView: 3,
                        spaceBetween: 35,
                    },
                },
            },
            swiperProgress: 0,
            showControls: false,
        }
    },
    methods: {
        prev() {
            this.swiper.slidePrev();
        },
        next() {
            this.swiper.slideNext();

        },
        onSlideChange() {
            this.swiperProgress = this.swiper.progress;
        },
        controlsView() {
            if (this.benefits.length > this.swiperOptions.breakpoints[this.swiper.currentBreakpoint].slidesPerView) {
                this.showControls = true;
            } else {
                this.showControls = false;
            }
        },
    },
    directives: {
        swiper: directive,
    },
    mounted() {
        this.controlsView()

        window.addEventListener('resize', () => {
             this.controlsView()
        })
    },
}
</script>
<style lang="scss">
@import "../../scss/base/include";

.benefits-list {
    @include mobile {
        position: relative;
        padding-bottom: 63px;
        margin-bottom: 40px;
    }

    &__title {
        @include tablet {
            font-size: 18px;
            line-height: 22px;
        }
        @include mobile {
            font-size: 24px;
            line-height: 120%;
            margin-bottom: 8px;
        }
    }

    &__top {
        position: relative;
        @include mobile {
            position: static;
        }
    }

    &__navigation {
        position: absolute;
        bottom: 0;
        right: 0;
        @include mobile {
            right: 24px;
        }

        button {
            background-color: transparent;
            width: 39px;
            height: 39px;
            background-image: url(/local/templates/pnd/src/assets/i/arrow.svg);
            background-position: 58% 50%;
            background-repeat: no-repeat;
            background-size: 9px auto;
            border: solid 1px $list-bullet;
            outline: none;
            border-radius: 50%;
            cursor: pointer;

            &:disabled {
                cursor: default;
                opacity: 0.3;
                border-color: $border;
            }

            &.prev {
                transform: scale(-1, 1);
            }

            &.next {
                margin-left: 8px;
            }
        }
    }

    &__subtitle {
        max-width: 740px;
        font-size: 18px;
        line-height: 27px;
        font-weight: normal;
        color: $gray;
        @include tablet {
            max-width: 502px;
            font-size: 16px;
            line-height: 24px;
        }
    }

    &__carousel {
        margin-top: 52px;
        margin-bottom: 22px;
        @include tablet {
            margin-top: 33px;
            margin-bottom: 0;
        }
    }

    &__item {
        @include tablet {
            max-width: 260px;
        }
        @include mobile {
            max-width: 100%;
            text-align: center;
        }

        &-image {
            @include size(220px, 222px);
            border-radius: 50%;
            margin-bottom: 43px;
            background-position: center;
            background-size: cover;
            @include tablet {
                @include size(172px, 174px);
                margin-bottom: 25px;
            }
            @include mobile {
                @include size(220px, 222px);
                margin: 0 auto 24px;
            }
        }

        &-name {
            margin-bottom: 9px;
            font-size: 18px;
            line-height: 21px;
            font-weight: normal;
            min-height: 42px;
            @include tablet {
                font-size: 16px;
                min-height: 38px;
                line-height: 19px;
            }
            @include mobile {
                min-height: 0;
            }
        }

        &-desc {
            font-size: 16px;
            line-height: 23px;
            font-weight: 300;
            font-family: 'HelveticaNeue';
            color: $gray;
            @include tablet {
                font-size: 14px;
                line-height: 142.9%;
                max-width: 260px;
            }
            @include mobile {
                margin: 0 auto;
            }
        }
    }
}

.benefits-list__carousel {
    padding-bottom: 50px;

    @include mobile {
        padding-bottom: 10px;
    }
}

.benefits-list__carousel .swiper-wrapper {
    margin-bottom: 20px;
}

.med-pnd-benefits-title {
    margin-bottom: 30px;
    font-size: 20px;
    font-weight: 700;
    line-height: 38px;
}

.med-pnd-benefits-text {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
}

.med-pnd-benefits-img,
.med-pnd-benefits-title,
.med-pnd-benefits-text {
     padding: 0 25px;

    @include tablet {
        padding: 0 20px;
    }

    @include mobile {
        padding: 0 15px;
    }
}
.swiper-slide.med-pnd-benefits-img-slider__item-wrapper {
    border-radius: 0px;
    height: auto;
}

.med-pnd-benefits-img-slider__item {
    box-shadow: 5px 10px 10px rgb(229 233 246 / 40%);
    border-radius: 8px;
    margin-right: 10px;
    height: 100%;
}

.benefits-list__carousel.nonEvent {
    pointer-events: none;
}
</style>
